import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
// import App from "./config/routes/App";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { Suspense } from "react";
if (process.env.NODE_ENV !== "production") {
	require("./styles/index.css");
} else {
	require("./styles/index.output.css");
}
i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.use(LanguageDetector)
	.use(HttpApi)
	.init({
		// the translations
		// (tip move them in a JSON file and import them,
		// or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
		supportedLngs: ["en", "ind"],
		fallbackLng: "en",
		detection: {
			// order and from where user language should be detected
			order: ["cookie", "localStorage"],
			caches: ["cookie"],
			lookupCookie: "lang",
			lookupLocalStorage: "lang",
		},
		backend: {
			loadPath: "/assets/locales/{{lng}}/translations.json",
		},
		allowMultiLoading: true,
		// react: { useSuspense: false },
	});

const LoadingMarkup = (
	<div className="min-h-screen w-full flex items-center justify-center dark:bg-dark bg-light">
		{/* <span className="text-xl text-yellow-500">Tes</span> */}
	</div>
);

const App = React.lazy(() => {
	return new Promise((resolve) => {
		setTimeout(() => resolve(import("./config/routes/App")), 10);
	});
});

ReactDOM.render(
	<Suspense fallback={LoadingMarkup}>
		<React.StrictMode>
			<Router>
				<App />
			</Router>
		</React.StrictMode>
	</Suspense>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
